// /******/ (() => { // webpackBootstrap
// var __webpack_exports__ = {};
// /*!********************************!*\
//   !*** ./src/js/video-mobile.js ***!
//   \********************************/
// $(document).ready(function () {
//   $('#lb-product-header-video-inner video').attr('class', 'display-video');
//   $("#lb-product-header-video-opener").click(function () {
//     $("#lb-product-header-video-inner").addClass("video-active");
//     $('#lb-product-header-video-inner video')[0].play();
//     $('#lb-product-header-video-inner video').attr('loop', 'loop');
//     $('#lb-product-header-video-inner').show();
//   });
//   $("#lb-product-header-video-inner").click(function () {
//     $("#lb-product-header-video-inner").removeClass("video-active");
//     $('#lb-product-header-video-inner video')[0].pause();
//   });
//   $("#cloose").click(function () {
//     $('#lb-product-header-video-inner').hide();
//     $("#lb-product-header-video-inner").removeClass("video-active");
//     $('#lb-product-header-video-inner video')[0].pause();
//   });
// });
// /******/ })()
// ;
$(document).ready(function () {
  $('#lb-product-header-video-inner video').attr('class', 'display-video');

  $("#lb-product-header-video-opener").click(function () {
    $("#lb-product-header-video-inner").addClass("video-active");
    $('#lb-product-header-video-inner video')[0].play();
    $('#lb-product-header-video-inner video').attr('loop', 'loop');
    $('#lb-product-header-video-inner').show();
  });

  $("#lb-product-header-video-inner").on('click', function (e) {
    if (e.target === this || e.target.id === 'cloose') {
      $("#lb-product-header-video-inner").removeClass("video-active");
      $('#lb-product-header-video-inner video')[0].pause();
      $('#lb-product-header-video-inner').hide();
    }
  });

  $("#cloose").click(function () {
    $('#lb-product-header-video-inner').hide();
    $("#lb-product-header-video-inner").removeClass("video-active");
    $('#lb-product-header-video-inner video')[0].pause();
  });
});
